import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthComponent } from './components/auth/auth.component';
import { AuthBarComponent } from './components/auth-bar/auth-bar.component';
import {
  DxButtonModule,
  DxDropDownButtonModule,
  DxPopoverModule,
  DxPopupModule,
} from 'devextreme-angular';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import { lucideTriangleAlert } from '@ng-icons/lucide';
import { ButtonDirective, ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [AuthComponent, AuthBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DxDropDownButtonModule,
    AuthRoutingModule,
    SharedModule,
    DxPopoverModule,
    DxButtonModule,
    BsDropdownModule,
    TranslateModule,
    NgIconsModule,
    ButtonModule,
  ],
  providers: [provideIcons({ lucideTriangleAlert })],
  exports: [AuthBarComponent],
})
export class AuthModule {}
